import axios from 'axios';
import {
    message,
} from 'antd';
import { ssoId } from './keyData';
import { ssoLogin } from '@hfe/sso-utils';

const axiosInstance = axios.create();
const isProd = window.location.hostname === 'debug.sankuai.com' || window.location.hostname === 'igate.waimai.st.sankuai.com' || window.location.hostname === 'debug.waimai.st.sankuai.com';
console.log(`sso - isprod: ${isProd}, hostname: ${window.location.hostname}`);
const isLocal = window.location.hostname === 'localhost' ||window.location.hostname === '127.0.0.1' ;
const hasLocalBackend = true;
axiosInstance.interceptors.response.use((response) => {
    const res = response.data;
    if (res.status === 401) {
        const host = `${window.location.protocol}//${window.location.hostname}`;
        let params = {
            env: 'ppe',
            clientId: ssoId.dev,
            host,
            ssoLoginUrl: '/toolsso/sso/callback',
            redirectUrl: `/tool/redirect?continue=${encodeURIComponent(window.location.href)}`,
        };
        if (isProd) {
            params = {
                ...params,
                env: 'prod',
                clientId: ssoId.prod,
            };
        } else if (isLocal) {
            if (hasLocalBackend) {
                params = {
                    ...params,
                    host: `${host}:7001`,
                    ssoLoginUrl: '/sso/callback',
                    redirectUrl: `/tool/redirect?continue=${encodeURIComponent(window.location.href)}`
                };
            } else {
                params = {
                    ...params,
                    host: window.location.origin,
                    ssoLoginUrl: '/toolsso/sso/callback',
                    redirectUrl: `/tool/redirect?continue=${encodeURIComponent(window.location.href)}`
                };
            }
        }
        console.log('登录参数', params);
        return ssoLogin(params);
    }
    return Promise.resolve(res);
});
// https://km.sankuai.com/page/239309604
export const get = (url, params) => axiosInstance.get(`${url}`, {
    params,
}).then((res = {}) => {
    if (res.code === 0) {
        return res.data;
    } else {
        if (res.status || res.code) {
            message.config({ maxCount: 1 });
            message.error(res.msg || '请求失败', 4);
        }
    }
    return false;
});

const locks = {};
export const post = (url, params, lockid) => {
    let lockCount = null;
    const axPromise = axiosInstance.post(`${url}`, params).then((res) => {
        if (res.code === 0) {
            return res.data;
        } else {
            if (res.status || res.code) {
                message.config({ maxCount: 1 });
                message.error(res.msg || '请求失败', 4);
            }
            return false;
        }
    }).then((res) => {
        if (locks[lockid] && lockCount !== locks[lockid]) {
            throw new Error('canceled');
        }
        return res;
    });

    if (lockid) {
        locks[lockid] = locks[lockid] + 1 || 1;
        lockCount = locks[lockid];
    }
    return axPromise;
};
